import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Custom hook for handling anchor scroll navigation
 * 
 * @param {string} anchorId - ID of the element to scroll to
 * @param {string} anchorPage - Route where the anchor exists (default: '/')
 * @returns {Function} - Click handler function
 */
export function useAnchorScroll() {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToAnchor = (anchorId, anchorPage = '/') => {
    return (e) => {
      e.preventDefault();
      
      const scrollToElement = (element) => {
        if (element) {
          // Calculate navbar height (approximately 64-80px depending on screen size)
          const navbarHeight = window.innerWidth < 600 ? 64 : 80;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navbarHeight - 20; // 20px extra padding
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      };
      
      if (location.pathname === anchorPage) {
        // If we're already on the target page, just scroll
        const element = document.getElementById(anchorId);
        scrollToElement(element);
      } else {
        // If we're on a different page, navigate first then scroll
        navigate(anchorPage);
        setTimeout(() => {
          const element = document.getElementById(anchorId);
          scrollToElement(element);
        }, 100);
      }
    };
  };

  return scrollToAnchor;
}

